import { ChangeDetectorRef, Component, effect, ElementRef, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'basys-authentication-webapi-editor',
  templateUrl: './webapi-editor.component.html',
  styleUrls: ['./webapi-editor.component.scss'],
  standalone: false,
})
export class WebApiEditorComponent implements OnInit {
  @Output() logoClick = new EventEmitter<void>();
  public res = ResourceSet.Empty;

  public readonly fallbackLogo = '/assets/resources/basys-core-authentication/BaSYS_logo.svg';
  public readonly fallbackIllustration = '/assets/resources/basys-core-authentication/BaSYS_Login_Illustration.png';
  public readonly fallbackCornerLogo = 'assets/resources/basys-core-authentication/BARTHAUER_software_RGB.png';
  public logo: string = this.fallbackLogo;
  public cornerLogo: string = this.fallbackCornerLogo;
  public illustration: string = this.fallbackIllustration;

  protected isMobileVersion: boolean;
  constructor(
    private config: AbcConfigService,
    private activatedRoute: ActivatedRoute,
    private resourceService: ResourceManagerService,
    private changeDetectorRef: ChangeDetectorRef,
    private host: ElementRef<HTMLElement>
  ) {
    this.isMobileVersion = false;

    effect(async () => {
      const routeData = await firstValueFrom(this.activatedRoute.data);
      this.res = await this.resourceService.getResourceSet('basys-core-authentication');

      const loginConfig = this.config.configuration.Style?.Login;

      this.logo = loginConfig?.Logo ?? routeData?.Logo ?? this.res.svgUrl('Logo-Image') ?? this.fallbackLogo;

      this.cornerLogo =
        loginConfig?.CornerLogo ??
        routeData?.CornerLogo ??
        this.res.svgUrl('CornerLogo-Image') ??
        this.fallbackCornerLogo;

      this.host.nativeElement.style.setProperty(
        '--corner-logo-image',
        this.cornerLogo ? `url('${this.cornerLogo}')` : 'none'
      );

      this.illustration =
        loginConfig?.Illustration ??
        routeData?.Illustration ??
        this.res.svgUrl('Loginscreen-Image') ??
        this.fallbackIllustration;

      if (loginConfig?.BackgroundColor) {
        document.documentElement?.style?.setProperty(
          '--login-container-controls-background-color',
          loginConfig.BackgroundColor
        );
      }
    });
  }

  ngOnInit(): void {
    const w = typeof window !== 'undefined' ? (window as any) : undefined;
    if (w?.cordova) {
      this.isMobileVersion = true;
    } else if (typeof document !== 'undefined') {
      document.addEventListener(
        'deviceready',
        () => {
          this.isMobileVersion = true;
          this.changeDetectorRef.markForCheck();
        },
        { once: true }
      );
    }

    if (!this.isMobileVersion && this.isTouchOrMobileBrowser()) {
      this.isMobileVersion = true;
      this.changeDetectorRef.markForCheck();
    }
  }

  private isTouchOrMobileBrowser(): boolean {
    return !!(
      'ontouchstart' in window ||
      (navigator.maxTouchPoints ?? 0) > 0 ||
      (navigator as any).msMaxTouchPoints > 0
    );
  }

  public onLogoClick(): void {
    this.logoClick.emit();
  }
}
